import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isMobile } from 'app/helpers/utils';

const H1 = styled.h1`
  font-size: ${({ size }) => size}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  letter-spacing: ${({ letterSpacing }) => letterSpacing}px;
  color: #000000;
  font-weight: 500;
  margin: 0;
  small {
    font-size: 18px;
    letter-spacing: 0.65px;
  }
  ${({ capitalize }) => capitalize && 'text-transform:capitalize;'};
  ${({ smallOnMobile }) =>
    smallOnMobile &&
    isMobile &&
    `
    font-size:27px;
    line-height: 34px;
    `};
`;

H1.defaultProps = {
  smallOnMobile: false,
  capitalize: false,
  size: 40,
  lineHeight: 43,
  letterSpacing: 1.44
};

H1.propTypes = {
  smallOnMobile: PropTypes.bool.isRequired,
  capitalize: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired,
  letterSpacing: PropTypes.number.isRequired
};

export default H1;
